import { useEffect, useRef } from "react";
import { useMap } from "react-leaflet";
import "@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css";
import "@geoman-io/leaflet-geoman-free";
import { useLanguage } from "./i18n";

export default function MeasureTool() {
  const map = useMap();
  const latestLineRef = useRef(null);
  const { t } = useLanguage(); // <-- LÄGG TILL DENNA RAD

  useEffect(() => {
    if (!map) return;

    map.pm.addControls({
      position: "topleft",
      drawMarker: false,
      drawCircle: false,
      drawCircleMarker: false,
      drawRectangle: false,
      drawPolygon: false,
      drawPolyline: true,
      editMode: false,
      dragMode: false,
      cutPolygon: false,
      removalMode: false,
      rotateMode: false,
      drawText: false,
    });

    // Byt ikon och text på polyline-knappen
    setTimeout(() => {
      const polyBtn = document.querySelector(".leaflet-pm-icon-polyline");
      if (polyBtn) {
        // Liten, mer motsols roterad linjal - något förminskad
        polyBtn.innerHTML = `
          <svg width="28" height="28" viewBox="0 0 32 32" fill="none">
            <!-- Linjal (motsols roterad, ca -50 grader, något mindre) -->
            <rect x="1" y="21" width="26" height="5" rx="2" fill="#ffe066" stroke="#333" stroke-width="1.7" transform="rotate(-50 1 21)" />
            <!-- Mätskalor -->
            <rect x="6" y="25" width="1.1" height="2.3" fill="#333" transform="rotate(-50 6 25)" />
            <rect x="12" y="27.8" width="1.1" height="2.3" fill="#333" transform="rotate(-50 12 27.8)" />
            <rect x="18" y="30.8" width="1.1" height="2.3" fill="#333" transform="rotate(-50 18 30.8)" />
            <rect x="24" y="33.7" width="1.1" height="2.3" fill="#333" transform="rotate(-50 24 33.7)" />
            <!-- Cirklar i ändarna -->
            <circle cx="3.5" cy="24.8" r="1.8" fill="#fff" stroke="#333" stroke-width="1.3"/>
            <circle cx="23.3" cy="11.6" r="1.8" fill="#fff" stroke="#333" stroke-width="1.3"/>
          </svg>
        `;
        // ÄNDRAT: Använd t('tooltip_measure') för både title och aria-label
        const tooltipText = t("tooltip_measure");
        polyBtn.title = tooltipText;
        polyBtn.setAttribute("aria-label", tooltipText);
        // Ändra Geoman-tooltip under knappen
        const parent = polyBtn.parentElement;
        if (parent && parent.querySelector(".leaflet-pm-toolbar-tooltip")) {
          parent.querySelector(".leaflet-pm-toolbar-tooltip").textContent = tooltipText;
        }
      }
    }, 400);

    function onCreate(e) {
      if (latestLineRef.current) {
        map.removeLayer(latestLineRef.current);
        latestLineRef.current = null;
      }
      latestLineRef.current = e.layer;

      let latlngs = e.layer.getLatLngs();
      if (Array.isArray(latlngs) && Array.isArray(latlngs[0])) {
        latlngs = latlngs[0];
      }
      let totalLength = 0;
      for (let i = 1; i < latlngs.length; i++) {
        totalLength += map.distance(latlngs[i - 1], latlngs[i]);
      }

      // Omvandla till km och nautiska mil
      const km = totalLength / 1000;
      const nm = totalLength / 1852;

      const popupHtml = `
        <div>
          <b>Totalt avstånd:</b><br>
          ${totalLength.toFixed(1)} m<br>
          ${km.toFixed(3)} km<br>
          ${nm.toFixed(3)} NM
        </div>
      `;

      e.layer.bindPopup(popupHtml).openPopup();

      e.layer.on('popupclose', () => {
        if (map.hasLayer(e.layer)) {
          map.removeLayer(e.layer);
          latestLineRef.current = null;
        }
      });
    }

    map.on("pm:create", onCreate);

    return () => {
      map.pm.removeControls();
      map.off("pm:create", onCreate);
      if (latestLineRef.current && map.hasLayer(latestLineRef.current)) {
        map.removeLayer(latestLineRef.current);
        latestLineRef.current = null;
      }
    };
  }, [map, t]); // <-- LÄGG TILL t som dependency!

  return null;
}